import React from 'react';
import {useSelector} from "react-redux";

const GeneratedShapeElements = (props) => {
    const shapes = useSelector(state => state.summaryReducer.shapes)

    if(shapes.length === 0){
        return null
    }

    /*
    "SIDE_ID": 1,
    "ELEM_SECT": 1,
    "ELEM_PWR": null,
    "ELEM_CAT": "L8",
    "IS_NODE": null
     */
    const displayGeneratedShapes = () => {
        const shapeView = [];
        for(let shape in shapes) {
            shapeView.push (
                <div>
                    <div>ID: {shapes[shape]['SIDE_ID']}</div>
                    <div>Section: {shapes[shape]['ELEM_SECT']}</div>
                    <div>PWR: {shapes[shape]['ELEM_PWR']}</div>
                    <div>Catalog: {shapes[shape]['ELEM_CAT']}</div>
                    <div>IS_NODE: {shapes[shape]['IS_NODE']}</div>
                    <hr />
                </div>
            )
        }

        return shapeView
    }

    return (
        <div className="panel" id="generated-elements">
            <div className="configurator-step element-wrapper">
                <div className="pattern-title-wrapper">
                    <div style={{display: 'flex', justifyContent:'space-between', alignItems: 'center'}}>
                        <h2>Generated Shapes</h2>
                    </div>
                </div>
                <div className='row'>
                    {displayGeneratedShapes()}
                </div>
            </div>
        </div>
    )
}

export default GeneratedShapeElements;

